
import React, { useEffect, useState } from "react";
import { BASE_API_URL } from "../services/baseServices";
import { ADD_CATEGORY } from "../services/categorieServices";
import { EDIT_CATEGORY } from "../services/categorieServices";
import MainLayout from "../layouts/MainLayout";
// import Swal from 'sweetalert2';
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Categories() {

    const navigate = useNavigate();
    const [sessionUserData, setSessionUserData] = useState([]);
    const [contentTypeData, setContentTypeData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [dataSubLoading, setDataSubLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [nameInput, setNameInput] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [editingItem, setEditingItem] = useState(null);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        if (sessionUserData?.OrgId) {
            fetchContentByType();
        }
    }, [sessionUserData]);

    const fetchContentByType = async (type) => {
        setDataLoading(true);

        try {
            const response = await axios.get(`${BASE_API_URL}ADMINRoutes/GetDDL?OrgId=${sessionUserData?.OrgId}&UserId=${sessionUserData?.Id}`);
            const allItems = response.data.ResultData;

            const contentTypesRes = allItems.filter(item => item.DDLName === "Categories");
            // console.log(contentTypesRes);

            setContentTypeData(contentTypesRes);
            setDataLoading(false);
        } catch (error) {
            console.error(`Error fetching ${type}:`, error);
            setDataLoading(false);
            return null;
        }
    };

    const filteredData = contentTypeData && contentTypeData.filter((item) => {
        const disValue = item?.DisplayValue?.toLowerCase() || '';

        const query = searchQuery.toLowerCase();

        return (
            disValue.includes(query)
        );
    });

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);

    // Get current records to display
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleEditClick = (item) => {
        setEditMode(true);
        setEditingItem(item);
        setNameInput(item.ItemValue);
    };

    const handleSubmit = async () => {
        if (!nameInput.trim()) return;

        try {
            setDataSubLoading(true);
            if (editMode && editingItem) {
                const payload = {
                    Id: editingItem.ItemId,
                    ContentTypeName: nameInput,
                    IsActive: 1,
                    UpdatedBy: sessionUserData?.Id,
                };
                await axios.post(`${BASE_API_URL}${EDIT_CATEGORY}`, payload);
            } else {
                const payload = {
                    ContentTypeName: nameInput,
                    IsActive: 1,
                    CreatedBy: sessionUserData?.Id,
                    OrgId: sessionUserData?.OrgId,
                };
                await axios.post(`${BASE_API_URL}${ADD_CATEGORY}`, payload);
            }

            setNameInput('');
            setDataSubLoading(false);
            setEditMode(false);
            setEditingItem(null);

            fetchContentByType();

        } catch (error) {
            console.error("Error submitting content type:", error);
            setDataSubLoading(false);
        }
    };

    const handleClear = () => {
        setNameInput('');
        setEditMode(false);
        setEditingItem(null);
        setDataSubLoading(false);
    };

    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Categories</h4>
                            <h6>Manage your categories</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        {/* <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="assets/img/icons/pdf.svg" alt="img"/></a>
                        </li>
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="assets/img/icons/excel.svg" alt="img"/></a>
                        </li> */}
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                    </ul>
                </div>
                <div className="row justify-content-evenly">
                    <div className="card col-6">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="d-flex align-items-center position-relative my-1">
                                    <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                    <input
                                        type="text"
                                        data-kt-customer-table-filter="search"
                                        className="form-control form-control-solid w-250px ps-13"
                                        placeholder="Search content type"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card-toolbar">
                                <div className="d-flex justify-content-end" data-kt-customer-table-toolbar="base"></div>
                                <div className="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                                    <div className="fw-bold me-5">
                                        <span className="me-2" data-kt-customer-table-select="selected_count"></span>Selected</div>
                                    <button type="button" className="btn btn-danger" data-kt-customer-table-select="delete_selected">Delete Selected</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_customers_table">
                                    <thead>
                                        <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="">S.No</th>
                                            <th className="min-w-125px">Name</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">
                                        {dataLoading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <div className="container"></div>
                                                </td>
                                            </tr>
                                        ) : currentRecords && currentRecords.length > 0 ? (
                                            currentRecords.map((item, index) => (
                                                <tr>
                                                    <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                    <td>
                                                        <a className="text-gray-800 text-hover-primary mb-1">{item.ItemValue}</a>
                                                    </td>
                                                    <td className="text-center">
                                                        <i className="fa-regular fa-pen-to-square cursor-pointer"
                                                            onClick={() => handleEditClick(item)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <p>No Data Available</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div className="dt-paging paging_simple_numbers">
                                    <nav aria-label="pagination">
                                        <ul className="pagination">
                                            <li
                                                className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                            >
                                                <button
                                                    className="page-link previous"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-disabled={currentPage === 1}
                                                    aria-label="Previous"
                                                    onClick={handlePrevious}
                                                >
                                                    <i className="previous"></i>
                                                </button>
                                            </li>

                                            {/* Page Numbers */}
                                            {getPaginationNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        role="link"
                                                        type="button"
                                                        aria-controls="kt_customers_table"
                                                        aria-current={page === currentPage ? "page" : undefined}
                                                        onClick={() => handlePageClick(page)}
                                                        disabled={page === "..."}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            {/* Next Button */}
                                            <li
                                                className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                            >
                                                <button
                                                    className="page-link next"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-disabled={currentPage === totalPages}
                                                    aria-label="Next"
                                                    onClick={handleNext}
                                                >
                                                    <i className="next"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card col-6">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <h3>{editMode ? "Edit Category" : "Add Category"}</h3>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="row">
                                <div>
                                    <label className="form-label">Name</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter category name"
                                        value={nameInput}
                                        onChange={(e) => setNameInput(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                    <button
                                        className="btn btn-secondary col-2 me-3"
                                        onClick={handleClear}
                                        disabled={dataSubLoading}
                                    >
                                        {dataSubLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            "Clear"
                                        )}
                                    </button>

                                    <button
                                        className="btn btn-primary col-2"
                                        onClick={handleSubmit}
                                        disabled={dataSubLoading}
                                    >
                                        {dataSubLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                {editMode ? "Updating..." : "Submitting..."}
                                            </>
                                        ) : (
                                            editMode ? "Update" : "Submit"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}